const CONFIG = {
  PRIVACYDOC: 'https://caebes.com:8000/docs/privacidad-datos-caebes.pdf',
  CONDITIONSDOC: 'https://caebes.com:8000/docs/terminos-condiciones-caebes.pdf',
  VERSION: '1.1.1',
};

export default CONFIG;
